import { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

export function Gallery({ images, alt, index }) {
    const imgs = images && images.length ? images : ["/img/placeholder.jpg"];
    const [i, setI] = useState(0);
    const multi = imgs.length > 1;

    const go = (dir) => (e) => {
        e.stopPropagation();
        setI((p) => (p + dir + imgs.length) % imgs.length);
    };

    return (
        <div className="relative aspect-square overflow-hidden" data-testid={`product-gallery-${index + 1}`}>
            <img
                key={imgs[i]}
                src={imgs[i]}
                alt={alt}
                loading="lazy"
                className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-[1.06]"
            />
            <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-ink2 via-transparent to-transparent opacity-80" />

            {multi && (
                <>
                    <button
                        type="button"
                        aria-label="Previous image"
                        data-testid={`gallery-prev-${index + 1}`}
                        onClick={go(-1)}
                        className="absolute left-3 top-1/2 z-10 grid h-9 w-9 -translate-y-1/2 place-items-center rounded-full border border-white/20 bg-ink/70 text-white opacity-0 backdrop-blur-md transition-all duration-300 hover:border-gold hover:text-gold group-hover:opacity-100"
                    >
                        <ChevronLeft className="h-4 w-4" />
                    </button>
                    <button
                        type="button"
                        aria-label="Next image"
                        data-testid={`gallery-next-${index + 1}`}
                        onClick={go(1)}
                        className="absolute right-3 top-1/2 z-10 grid h-9 w-9 -translate-y-1/2 place-items-center rounded-full border border-white/20 bg-ink/70 text-white opacity-0 backdrop-blur-md transition-all duration-300 hover:border-gold hover:text-gold group-hover:opacity-100"
                    >
                        <ChevronRight className="h-4 w-4" />
                    </button>
                    <div className="absolute bottom-3 left-1/2 z-10 flex -translate-x-1/2 gap-1.5">
                        {imgs.map((img, d) => (
                            <button
                                key={img}
                                type="button"
                                aria-label={`View image ${d + 1}`}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setI(d);
                                }}
                                className={`h-1.5 rounded-full transition-all duration-300 ${
                                    d === i ? "w-5 bg-gold" : "w-1.5 bg-white/40 hover:bg-white/70"
                                }`}
                            />
                        ))}
                    </div>
                    <span className="absolute bottom-3 right-3 z-10 rounded-full bg-ink/70 px-2 py-0.5 font-mono text-[10px] text-white backdrop-blur-md">
                        {i + 1}/{imgs.length}
                    </span>
                </>
            )}
        </div>
    );
}
